import React, { Component } from 'react';
import range from 'lodash/range';
import moment from 'moment';
import 'moment-timezone';
import PropTypes from 'prop-types';
import DataPopover from 'components/DataPopover';
import PostActions from 'components/FeedList/Post/PostActions';
import ProfileIcon from 'components/ProfileIcon';
import TimeSince from 'components/TimeSince';
import { fromIso9075DateString } from 'utils/dates';
import { userShape, wallPostShape } from 'utils/shapes';
import WindCreekWImage from 'resources/WindCreekWGray.svg';
import PostPicture from '../PostPicture';
import './TournamentFinished.css';

class TournamentFinished extends Component {
  render() {
    const {
      post,
      user,
      showLegacyFeed,
      toggleComments,
      onUnpinWallPost,
      onPinWallPost,
      onLikePost,
      onUnlikePost,
      onDeletePost,
      onLockWallPost,
      onUnlockWallPost
    } = this.props;

    const json = JSON.parse(post.message);
    const { name: tournamentName, start, winners } = json;

    const startDate = moment(start);
    const timeString = startDate
      .format(startDate.minutes() ? 'h:mm A' : 'h A')
      .replace(' ', '\u00A0');
    const className = showLegacyFeed
      ? 'legacy-feed-tournament-finished'
      : 'feed-tournament-finished';

    return (
      <div className={className}>
        <div className="feed-message-specifics">
          <ProfileIcon size={30} src={WindCreekWImage} />
          <div className="feed-message-author-container">
            <strong>A Tournament has finished!</strong>
            <div className="post-time">
              <TimeSince
                date={fromIso9075DateString(post.created)}
                prefix="posted"
              />
            </div>
          </div>
        </div>

        <div className="tournament-finished-container">
          <PostPicture
            date={fromIso9075DateString(post.created)}
            alt="A Tournament has finished"
          />
          <div className="tournament-finished-message">
            <span className="tournament-finished-title">{tournamentName}</span>
            {winners && winners.length === 1 && (
              <div className="tournament-finished-message-winner">
                Congratulations to
                <span className="tournament-finished-name">
                  {' '}
                  {winners[0]}
                </span>{' '}
                on winning our {timeString} Tournament! Your prize has been
                added to your account.
              </div>
            )}
            {winners && winners.length > 1 && winners.length < 6 && (
              <div className="tournament-finished-message-winner">
                Congratulations to
                {winners.map((name, index) => {
                  let delimiter;
                  switch (index) {
                    case winners.length - 1:
                      delimiter = '';
                      break;
                    case winners.length - 2:
                      delimiter = ' and';
                      break;
                    default:
                      delimiter = ',';
                      break;
                  }
                  return (
                    <React.Fragment key={index}>
                      <span className="tournament-finished-name"> {name}</span>
                      {delimiter}
                    </React.Fragment>
                  );
                })}{' '}
                on winning our {timeString} Tournament! Your prizes have been
                added to your accounts.
              </div>
            )}
            {winners && winners.length >= 6 && (
              <>
                <div className="tournament-finished-message-winner">
                  Congratulations to the winners of our {timeString} Tournament!
                  Your prizes have been added to your accounts.
                </div>

                <div className="tournament-finished-winners">
                  <DataPopover
                    tooltipMessage={<WinnersTooptip entries={winners} />}
                    tooltipClass="tournament-finished-winners-tooltip"
                    trigger="click"
                    rootClose
                  >
                    <WinnersButton text="view winners" />
                  </DataPopover>
                </div>
              </>
            )}
          </div>
        </div>
        <PostActions
          post={post}
          user={user}
          toggleComments={toggleComments}
          onUnpinWallPost={onUnpinWallPost}
          onPinWallPost={onPinWallPost}
          onLikePost={onLikePost}
          onUnlikePost={onUnlikePost}
          onDeletePost={onDeletePost}
          onLockWallPost={onLockWallPost}
          onUnlockWallPost={onUnlockWallPost}
        />
      </div>
    );
  }
}

TournamentFinished.propTypes = {
  user: userShape,
  post: wallPostShape,
  showLegacyFeed: PropTypes.bool,
  onDeletePost: PropTypes.func,
  toggleComments: PropTypes.func,
  onLikePost: PropTypes.func,
  onUnlikePost: PropTypes.func,
  onPinWallPost: PropTypes.func,
  onUnpinWallPost: PropTypes.func
};

export default TournamentFinished;

function WinnersButton({ text, ...props }) {
  return (
    <button
      className="btn button-color-green tournament-finished-button"
      value="View Winners"
      type="button"
      {...props}
    >
      {text}
    </button>
  );
}

function WinnersTooptip({ entries }) {
  const maxCols = 4;
  let numOfCols = Math.ceil(Math.sqrt(entries.length / 2));
  let numOfRows = Math.ceil(numOfCols * 2);
  if (numOfCols > maxCols) {
    numOfCols = maxCols;
    numOfRows = Math.ceil(entries.length / numOfCols);
  }
  return (
    <table className="tooltip-table">
      <tbody>
        {range(numOfRows).map(rowIdx => {
          return (
            <tr key={rowIdx}>
              {range(numOfCols).map(colIdx => {
                const entry = entries[numOfRows * colIdx + rowIdx];
                return entry && <td key={entry}>{entry}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
